import * as React from "react";
import Seo from "../components/seo";
import { Link } from "gatsby";
import ClientsTestimonial from "../components/clients-testimonial";
import Awards from "../components/awards";
import OurClients from "../components/our-clients";
import BlogList from "../components/blog/blog-list";
import CaseStudy from "../components/case-study";
import BannerForm from "../components/banner-form";
import { Container, Row, Col, } from "react-bootstrap";
import { BlockchainAppDevelopmentServicesMeta } from "../data/metaData";
import Layout from "../components/layout/layout";

import bannerImage from "../images/web-development-banner.jpg";

export const Head = () => (
  <Seo
    title={BlockchainAppDevelopmentServicesMeta.metaTitle}
    description={BlockchainAppDevelopmentServicesMeta.metaDescription}
    ogImage={BlockchainAppDevelopmentServicesMeta.ogImage}
    twitterImage={BlockchainAppDevelopmentServicesMeta.twitterImage}
  />
)

const BlockchainAppDevelopmentServicesPage = () => {

  const choosedata = [
    {
      class: "leading-icon1",
      title: "Private Blockchain Development",
      des: "Peerbits is adept at delivering Private Blockchain Development Solutions which helps you in faster, cheaper, and low-risk transactions."
    },
    {
      class: "leading-icon2",
      title: "Decentralized Application Development (dApps)",
      des: "Providing secure solutions is our prime objective. In a short span of time, we have offered Full-proof Decentralized Application Development solutions for clients who have high-security needs."
    },
    {
      class: "leading-icon3",
      title: "Crypto Exchange Development",
      des: "We are a prominent name when it comes to delivering Crypto Exchange Development. Experience seamless and secure cryptocurrency exchange with our esteemed bitcoin developers."
    },
    {
      class: "leading-icon4",
      title: "Smart Contracts Development (ICO)",
      des: "We have successfully delivered customized Smart Contract solutions which help companies to execute their ideas without any middlemen or any other intervention. Our solutions have also assisted in the reduction and automation of costs and tasks respectively."
    },
    {
      class: "leading-icon5",
      title: "Wallet Development Solutions",
      des: "Peerbits has extended its mastery from cryptocurrencies to development of secure and stable wallet services. Our Wallet Services are well within the industrial regulations and ensure safe cryptocurrency management."
    },
    {
      class: "leading-icon6",
      title: "Blockchain Technology Consulting",
      des: "Experience of delivering numerous solutions in Blockchain technology makes us a prominent source for providing consultations on Blockchain technology. We suggest which of the Blockchain technology is suitable for you and how to execute it."
    },
    {
      class: "leading-icon7",
      title: "Distributed E-Commerce Solution",
      des: "Blockchain has revolutionized the e-Commerce sector. With Peerbits’ distributed e-Commerce solution you can transform your e-commerce platform into a safe, fast, and cost-efficient entity."
    },
    {
      class: "leading-icon8",
      title: "Blockchain IoT App Development",
      des: "One of the critical threat that IoT faces is the security due to its client/server model. We provide Blockchain Solutions for IoT which are secure and foolproof from all risks."
    },
  ]

  const benefits = [
    {
      class: "key-benefits-icon1",
      title: "Transparency",
      des: "Blockchain technology caters greater transparency with the distributed ledger system. All the participants share the same documentation, and an update must have consensus. This nature of blockchain makes data complete, accurate, and consistent."
    },
    {
      class: "key-benefits-icon2",
      title: "Security",
      des: "The blockchain is secure due to its record-keeping systems. Transactions are approved, encrypted and linked to the previous transaction. Storage of data is in the network of computers instead of a single sever making it difficult for hackers to hack."
    },
    {
      class: "key-benefits-icon3",
      title: "Reduced Cost",
      des: "Blockchain eliminates the intermediaries from the equation. It cuts a significant amount of cost. It’s only you and your trading partner; the best part is that it is still secure."
    },
    {
      class: "key-benefits-icon4",
      title: "Increased Efficiency and Speed",
      des: "Traditional trading processes are time-consuming and prone to human error. Blockchain automating these processes helps in speeding up and improving the efficiency of the transactions."
    },
    {
      class: "key-benefits-icon5",
      title: "Traceability",
      des: "All the information is relayed and transferred to or from the new participant for possible action. This nature of Blockchain helps in tracking data and hence increasing the traceability."
    },
    {
      class: "key-benefits-icon6",
      title: "Auditability",
      des: "Record of each transaction is sequential, and it is there for everyone to see. It makes auditing of any deal an easy job."
    },
  ]

  const lastsec = [
    {
      class: "applications-icon1",
      title: "Transactions",
    },
    {
      class: "applications-icon2",
      title: "Data management",
    },
    {
      class: "applications-icon3",
      title: "Healthcare",
    },
    {
      class: "applications-icon4",
      title: "IoT",
    },
    {
      class: "applications-icon5",
      title: "Real estate",
    },
    {
      class: "applications-icon6",
      title: "Ride-sharing services",
    },
    {
      class: "applications-icon7",
      title: "Social networks",
    },
    {
      class: "applications-icon8",
      title: "Digital identity",
    },
    {
      class: "applications-icon9",
      title: "Asset management",
    },
    {
      class: "applications-icon10",
      title: "Energy Trading",
    },
    {
      class: "applications-icon11",
      title: "Shipping and Logistics",
    },
    {
      class: "applications-icon12",
      title: "Copyright and royalty",
    },
  ]

  return (
    <>

      <Layout headerClass="navbar-dark">
        <section className="section banner-image" style={{ backgroundImage: `url(${bannerImage})` }}>
          <Container className="py-5 mt-lg-5">
            <Row className="align-items-center g-5">
              <Col lg={6}>
                <h1 className="mb-4 text-white">
                  <span className="text-primary">Blockchain</span> development company
                </h1>
                <p className="lead mb-0 text-white-75">
                  The advent of Blockchain Technology has drawn the attention of many app development firms. Peerbits has attained the reputation by delivering exceptional blockchain app development solutions. Our team of elite Blockchain developers equipped with outstanding skillset will provide you with the desired solution.
                </p>
              </Col>
              <Col lg={6}>
                <BannerForm />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Our <span className="text-primary">Blockchain</span> Development Services
              </h2>
              {/* <p className="max-width-950 lead">As a leading frontend developer, we have delivered hundreds of projects in technologies like React JS, Angular JS and Vue JS. We have the required expertise and experience.</p> */}
            </div>
            <Row className="g-4" xs={1} md={2} lg={3} xl={4}>

              {
                choosedata.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-1 center-icon-box text-center equal-height">
                      <i className={`blockchain-app-development-sprite ${item.class} icon-size-70 mb-4`}></i>
                      <h3 className="text-center h4 mb-3">{item.title}</h3>
                      <p className="mb-0">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                How <span className="text-primary">Blockchain</span> Works
              </h2>
              <p className="max-width-950 lead">Blockchain works on the principle that allows a group of connected computers to maintain a single updated and secure ledger.</p>
            </div>
            <Row className="g-3 g-lg-0" xs={1} md={2} lg={5}>
              <Col>
                <div className="dark-box-2 center-icon-box text-center equal-height rounded-0">
                  <i className="blockchain-app-development-sprite blockchain-icon1 icon-size-70 mb-4"></i>
                  <h3 className="text-center h4 mb-0">Initiation of Transaction</h3>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="p-4 equal-height align-items-center d-flex justify-content-center">
                  <h3 className="text-center mb-0">2</h3>
                </div>
              </Col>
              <Col>
                <div className="dark-box-2 center-icon-box text-center equal-height rounded-0">
                  <i className="blockchain-app-development-sprite blockchain-icon3 icon-size-70 mb-4"></i>
                  <h3 className="text-center h4 mb-0">Block Creation</h3>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="p-4 equal-height align-items-center d-flex justify-content-center">
                  <h3 className="text-center mb-0">4</h3>
                </div>
              </Col>
              <Col>
                <div className="dark-box-2 center-icon-box text-center equal-height rounded-0">
                  <i className="blockchain-app-development-sprite blockchain-icon5 icon-size-70 mb-4"></i>
                  <h3 className="text-center h4 mb-0">Post Verification</h3>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="p-4 equal-height align-items-center d-flex justify-content-center">
                  <h3 className="text-center mb-0">1</h3>
                </div>
              </Col>
              <Col>
                <div className="dark-box-2 center-icon-box text-center equal-height rounded-0">
                  <i className="blockchain-app-development-sprite blockchain-icon2 icon-size-70 mb-4"></i>
                  <h3 className="text-center h4 mb-0">Encryption of Identities</h3>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="p-4 equal-height align-items-center d-flex justify-content-center">
                  <h3 className="text-center mb-0">3</h3>
                </div>
              </Col>
              <Col>
                <div className="dark-box-2 center-icon-box text-center equal-height rounded-0">
                  <i className="blockchain-app-development-sprite blockchain-icon4 icon-size-70 mb-4"></i>
                  <h3 className="text-center h4 mb-0">Noding</h3>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="p-4 equal-height align-items-center d-flex justify-content-center">
                  <h3 className="text-center mb-0">5</h3>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section ">
          <Container className="py-5">
            <div className="text-center py-lg-5">
              <h2 className="mb-4">
                Looking to Hire <span className="text-primary">Blockchain <br />Development</span> Experts? Contact Us.
              </h2>
              <p className="lead max-width-950 mx-auto">Peerbits is a leading Blockchain Development company which has delivered various customized and high-quality solutions. We have a pool of talented and accomplished Blockchain experts who will mold and nurture your product and will support you at every stage.</p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Get in touch
              </Link>
            </div>
          </Container>
        </section>

        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Blockchain Technology’s Key <span className="text-primary">Benefits</span>
              </h2>
              <p className="max-width-950 lead">Blockchains technology is here to stay. It comes with many benefits which are common to many industries. These Path-breaking benefits will redefine the way we work. Below are some of them.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              {
                benefits.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 center-icon-box text-center equal-height">
                      <i className={`blockchain-app-development-sprite ${item.class} icon-size-70 mb-4`}></i>
                      <h3 className="text-center h4 mb-3">{item.title}</h3>
                      <p className="mb-0">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Applications of <span className="text-primary">Blockchain</span>
              </h2>
              <p className="max-width-950 lead">Blockchain Technology is a vast concept; some compare it with the internet itself. Blockchain has a humungous scope. It can be used in many industries and fields as the benefits offered by it serves all of them. Below are few of the Blockchain applications.</p>
            </div>
            <Row as="ul" xs={1} sm={2} lg={3} className="list-unstyled g-4">
              {
                lastsec.map((item, index) => (
                  <Col as="li" key={index}>
                    <div className="dark-box-1 d-flex align-items-center p-3 rounded-3">
                      <i className={`blockchain-app-development-sprite ${item.class} icon-size-60 me-3`}></i>
                      <h3 className="h4 fw-normal">{item.title}</h3>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <ClientsTestimonial />
        <Awards />
        <OurClients />
        <CaseStudy />
        <BlogList />
      </Layout>
    </>
  );
};

export default BlockchainAppDevelopmentServicesPage;
